import React, { useEffect, useState } from 'react'
import styles from './Dashboard.module.scss';
import WeeklyTrend from './Charts/WeeklyTrend';
import SalesChart from './Charts/SalesChart';
import MarketGrowthChart from './Charts/MarketGrowthChart';
import axios from 'axios';
import { getStoredToken } from '../../utils/authUtils';
import { apiConfig } from '../../config/apiConfig';

function TopSectionCharts() {

  const [isInitialLoading, setIsInitialLoading] = useState<boolean>(true);
  const [totalProducts, setTotalProducts] = useState<number>(0);

    useEffect(() => {
        const timer = setTimeout(() => {
          setIsInitialLoading(false);
        }, 600); //  0.6 seconds delay

        // cleanup to avoid memory leaks
        return () => clearTimeout(timer);
    }, []);

    // Fetch total products from DAM API
    useEffect(() => {
      const fetchTotalProducts = async () => {
        try {
          const token = getStoredToken();
          if (!token) {
            console.log('No token found');
            return;
          }

          const response = await axios.get(
            apiConfig.dam.digitalAssets,
            {
              headers: {
                'Content-Type': 'application/json',
                'Authorization': token.startsWith('Bearer ') ? token : `Bearer ${token}`,
              },
            }
          );

          // Set total products based on array length
          if (Array.isArray(response.data)) {
            setTotalProducts(response.data.length);
          } else if (response.data?.data && Array.isArray(response.data.data)) {
            setTotalProducts(response.data.data.length);
          }
        } catch (error: any) {
          console.error('Failed to fetch total products:', error);
          setTotalProducts(0);
        }
      };

      fetchTotalProducts();
    }, []);



  return (
    <section className={`${styles.dashboard_overview} ${isInitialLoading && styles.blur_view}`}>
          <article className={styles.dashboard_left}>
            <div className={styles.overview_card}>
              <small>Total Products</small>
              <div className={styles.overview_card_value}>{totalProducts}</div>
            </div>
            <div className={styles.overview_card}>
              <small>Total Revenue</small>
              <div className={styles.overview_card_value}>$ 0</div>
            </div>
            <div className={styles.overview_card}>
              <small>Orders</small>
              <div className={styles.overview_card_value}>0</div>
            </div>
          </article>
          <article className={styles.dashboard_middle}>
            <div className={styles.overview_card}>
              <small>Sales Statistic</small>
              {/* <BarChartNew data={data} width={500} height={240}  /> */}
              <SalesChart
                months={["Jan", "Feb", "Mar", "Apr", "May", "Jun","Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]}
                sales={[0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,]}
              />
            </div>
           
          </article>
          <article className={styles.dashboard_right}>
            <div className={styles.overview_card}>
              <small>Market Growth</small>
              <div className={styles.market_growth}>
                <MarketGrowthChart
                  highlightIndex={6}
                  data={[ 8, 14, 20, 27, 35, 42, 50]}
                />  
                <aside>
                  <div className={styles.rate}><span>453 </span><small  className={styles.red}>-8% </small></div>
                  <sub>Transaction</sub>
                </aside>    
              </div>
              
            </div>
            <div className={styles.overview_card}>
              <small>Weekly Trend</small>
              <WeeklyTrend
                days={["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]}
                values={[12, 18, 9, 22, 30, 17, 25]}
              />
            </div>
            
          </article>
        </section>
  )
}

export default TopSectionCharts